export const DEBOUNCE_TIME = 200;
export const DEFAULT_MAX_TARGET_POINTS_TRANSFER = 1000000;
